import RIGHT_PANEL_TABS_TEMPLATE from "./components/modules/dynamic-views/view-management/config/right-panel-tabs.template";

const NO_SUBTABS = [];

export const getViewTabs = (viewName) => RIGHT_PANEL_TABS_TEMPLATE[viewName] ?? NO_SUBTABS;

export const getSubtabs = (tab) => tab?.subtabs ?? NO_SUBTABS;

export const hasSubtabs = (tab) => getSubtabs(tab).length > 0;

export const buildRouteId = (...parts) => parts.join("__");

export const buildTabPath = (viewName, id, tab) =>
  hasSubtabs(tab)
    ? `/${viewName}/${id}/${tab.key}/${getSubtabs(tab)[0].key}`
    : `/${viewName}/${id}/${tab.key}`;
